import React, { forwardRef, useContext } from 'react';
import TabNav from '../../Common/Form/Tab/TabNav';
import { TabContext } from '../../Common/Form/Tab/TabContext';
import TabContent from '../../Common/Form/Tab/TabContent';
import AgendaTable from '../AgendaTable';
import dayjs from 'dayjs';
import Button from '../../Common/Form/Button';
import PropTypes from 'prop-types';

const scroll = (ref) => {
    ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
};

const StepOne = ({ ref, event, sessions: sessionsById, setSessions }) => {
    const { tabIndex: outerTabIndex, setTabIndex: outerSetTabIndex } = useContext(TabContext);

    const [innerTabIndex, setInnerTabIndex] = React.useState(0);

    if (!event) {
        return null;
    }

    return (
        <div className={`${outerTabIndex !== 0 ? 'hidden' : ''}`}>
            <span className="caps">Step 1 of 2</span>
            <h3 className="registration__heading">Sessions</h3>
            <p>Please choose the sessions you plan to attend.</p>

            <div className="-agenda -condensed tabs">
                <TabContext.Provider
                    value={{
                        tabIndex: innerTabIndex,
                        setTabIndex: setInnerTabIndex,
                        tabCount: Object.keys(event.sessions).length,
                    }}
                >
                    <TabNav>
                        {Object.keys(event.sessions).map((date) => (
                            <span key={`tabnav-session-${date}`}>{dayjs(date).format('dddd, MMM D')}</span>
                        ))}
                    </TabNav>
                    <TabContent>
                        {Object.entries(event.sessions).map(([date, agenda], idx) => (
                            <div
                                key={`tabcontent-session-${date}`}
                                className={`${innerTabIndex !== idx ? 'hidden' : ''}`}
                            >
                                <div className="responsive-table">
                                    <AgendaTable agenda={agenda} sessions={sessionsById} setSessions={setSessions} />
                                </div>

                                {idx < Object.keys(event.sessions).length - 1 && (
                                    <Button
                                        text={`Continue to ${dayjs(Object.keys(event.sessions)[idx + 1]).format(
                                            'dddd, MMM D'
                                        )}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setInnerTabIndex((val) => val + 1);
                                            scroll(ref);
                                        }}
                                    />
                                )}

                                {idx === Object.keys(event.sessions).length - 1 && (
                                    <Button
                                        text="Continue to Next Step"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            outerSetTabIndex(1);
                                            scroll(ref);
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                    </TabContent>
                </TabContext.Provider>
            </div>
        </div>
    );
};

StepOne.propTypes = {
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
    event: PropTypes.object,
    sessions: PropTypes.object,
    setSessions: PropTypes.func,
};

export default forwardRef((props, ref) => StepOne({ ...props, ref }));
